var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgThumbnailCloseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.64017 2.35983C9.78661 2.50628 9.78661 2.74372 9.64017 2.89017L2.89017 9.64017C2.74372 9.78661 2.50628 9.78661 2.35983 9.64017C2.21339 9.49372 2.21339 9.25628 2.35983 9.10983L9.10983 2.35983C9.25628 2.21339 9.49372 2.21339 9.64017 2.35983Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.35983 2.35983C2.50628 2.21339 2.74372 2.21339 2.89017 2.35983L9.64017 9.10983C9.78661 9.25628 9.78661 9.49372 9.64017 9.64017C9.49372 9.78661 9.25628 9.78661 9.10983 9.64017L2.35983 2.89017C2.21339 2.74372 2.21339 2.50628 2.35983 2.35983Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbnailCloseIcon);
export default __webpack_public_path__ + "static/media/thumbnail-close-icon.842e4883cbb256d7602801f7546aa501.svg";
export { ForwardRef as ReactComponent };